module.exports = __webpack_public_path__ + "img/bostie_and_leash.5c0b1be4.svg";